import React, { Component } from "react";
import logo from "../images/logo.svg";
import { withRouter } from "../components/withRouter";
import { LogoSvg } from "../components/loading";
import { hostsSettings } from "../configs/app.config";
import ConfirmaitonModal from "../components/confirmation_modal";
import moment from "moment";
import WebApp from "@twa-dev/sdk";

class LoginCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      intermediatePin: Array(4).fill(""),
      pin: Array(4).fill(""),
      currentIndex: 0,
      intermediate: null,
      error: null,
      isLoading: true,
      firstTry: 0,
      confirmation: false,
    };
    this.inputRefs = [];
  }

  handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;

    const newPin = [...this.state.pin];
    newPin[index] = value;

    this.setState(
      {
        pin: newPin,
        currentIndex: value ? Math.min(index + 1, 3) : index,
        error: null,
      },
      () => {
        if (value && this.inputRefs[this.state.currentIndex]) {
          this.inputRefs[this.state.currentIndex].focus();
        }

        if (newPin.every((digit) => digit !== "")) {
          this.verifyPin(newPin.join(""));
        }
      }
    );
  };

  handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !this.state.pin[index] && index > 0) {
      this.setState(
        {
          currentIndex: index - 1,
        },
        () => {
          this.inputRefs[this.state.currentIndex].focus();
        }
      );
    }
  };

  handleNumberClick = (number) => {
    const { currentIndex } = this.state;
    if (currentIndex < 4) {
      this.handleChange(currentIndex, number.toString());
    }
  };

  handleBackspaceClick = () => {
    const { currentIndex, pin } = this.state;
    const newPin = [...pin];

    if (pin[currentIndex] !== "") {
      newPin[currentIndex] = "";
    } else if (currentIndex > 0) {
      newPin[currentIndex - 1] = "";
      this.setState(
        {
          currentIndex: currentIndex - 1,
        },
        () => {
          this.inputRefs[this.state.currentIndex].focus();
        }
      );
    }

    this.setState({ pin: newPin, error: null });
  };

  verifyPin = (enteredPin) => {
    if (this.state.firstTry == 1) {
      this.setState(
        {
          intermediatePin: this.state.pin.join(""),
          firstTry: 2,
          error: null,
          intermediate: "Повторите код",
          pin: Array(4).fill(""),
          currentIndex: 0,
          isLoading: false,
        },
        () => {
          if (this.inputRefs[0]) {
            this.inputRefs[0].focus();
          }
        }
      );
    } else if (this.state.firstTry == 2) {
      if (this.state.intermediatePin == this.state.pin.join("")) {
        this.setState(
          {
            intermediatePin: Array(4).fill(""),
            firstTry: 3,
            intermediate: null,
            error: null,
            currentIndex: 0,
            isLoading: false,
          },
          () => {
            if (this.inputRefs[0]) {
              this.verifyPin(this.state.pin);
            }
          }
        );
      } else {
        this.setState(
          {
            intermediatePin: Array(4).fill(""),
            pin: Array(4).fill(""),
            firstTry: 1,
            intermediate: null,
            error: "Код не совпадает, попробуйте заного",
            pin: Array(4).fill(""),
            currentIndex: 0,
            isLoading: false,
          },
          () => {
            if (this.inputRefs[0]) {
              this.inputRefs[0].focus();
            }
          }
        );
      }
    } else {
      this.setState({ isLoading: true });
      fetch(hostsSettings.apiPage + "/login-code" + (this.state.firstTry == 3 ? "/create" : ""), {
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json; charset=utf-8",
          Authorization: "Bearer " + localStorage.getItem("digitalkassir_idtn_cms_frm"),
        }),
        method: "POST",
        cache: "no-cache",
        mode: "cors",
        credentials: "include",
        body: JSON.stringify({
          chat: WebApp?.initData,
          code: this.state.pin.join(""),
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (!res.error) {
            //TOOD подумать по поводу авторизации после кода доступа
            sessionStorage.setItem("digitalkassir_appCode", res.data);
            this.props.navigate("/main");
          } else {
            this.setState(
              {
                error: "Неверный код доступа",
                pin: Array(4).fill(""),
                currentIndex: 0,
                isLoading: false,
                firstTry: 0,
                intermediate: null,
                intermediatePin: Array(4).fill(""),
              },
              () => {
                if (this.inputRefs[0]) {
                  this.inputRefs[0].focus();
                }
              }
            );
          }
        });
    }
  };

  getCodeInfo() {
    fetch(hostsSettings.apiPage + "/login-code/get", {
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("digitalkassir_idtn_cms_frm"),
      }),
      method: "POST",
      cache: "no-cache",
      mode: "cors",
      credentials: "include",
      body: JSON.stringify({
        chat: WebApp?.initData,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (!res.error) {
          if (res?.data == "first try") {
            this.setState({ firstTry: 1, isLoading: false });
          } else if (res?.data == "ok") {
            this.setState({ isLoading: false });
          } else if (res?.data == "none") {
            // this.props.navigate("/");
          }
        } else {
          // this.props.navigate("/");
        }
      });
  }

  handleSomeAction = () => {
    this.setState({ confirmation: false });
  };

  render() {
    const { pin, error, intermediate, isLoading } = this.state;
    const tg = window.Telegram?.WebApp;
    return (
      <div className="loginCodeBody">
        <div>
          <img style={{ margin: "0 auto", display: "block", marginBottom: 30 }} src={logo} alt="logo" />
          <h1 className="login-title">{this.state.firstTry == 1 ? "Придумайте код доступа" : "Введите код доступа"}</h1>
          <div className="pin-input-container">
            {pin.map((digit, index) => (
              <input
                key={index}
                type="password"
                maxLength={1}
                value={digit}
                onChange={(e) => this.handleChange(index, e.target.value)}
                onKeyDown={(e) => this.handleKeyDown(index, e)}
                ref={(el) => (this.inputRefs[index] = el)}
                className={`pin-input ${error ? "error" : ""} ${intermediate ? "intermediate" : ""}`}
                disabled
              />
            ))}
          </div>

          {error && <div className="error-message">{error}</div>}
          {intermediate && <div className="intermediate-message">{intermediate}</div>}
        </div>
        {isLoading ? (
          <div>
            <div className="loader">Проверка кода...</div>
            <div className="loading_logo">
              <LogoSvg />
            </div>
          </div>
        ) : (
          <div className="keyboard">
            <div className="keyboard-row">
              {[1, 2, 3].map((num) => (
                <button key={num} className="key-button" onClick={() => this.handleNumberClick(num)}>
                  {num}
                </button>
              ))}
            </div>
            <div className="keyboard-row">
              {[4, 5, 6].map((num) => (
                <button key={num} className="key-button" onClick={() => this.handleNumberClick(num)}>
                  {num}
                </button>
              ))}
            </div>
            <div className="keyboard-row">
              {[7, 8, 9].map((num) => (
                <button key={num} className="key-button" onClick={() => this.handleNumberClick(num)}>
                  {num}
                </button>
              ))}
            </div>
            <div className="keyboard-row">
              <button className="key-button empty" disabled></button>
              <button className="key-button" onClick={() => this.handleNumberClick(0)}>
                0
              </button>
              <button className="key-button backspace" onClick={this.handleBackspaceClick}>
                ⌫
              </button>
            </div>
          </div>
        )}

        {this.state.confirmation == true ? (
          <ConfirmaitonModal
            closeAction={this.handleSomeAction}
            image="🤔"
            title="Сохранить код доступа?"
            description="Этот код предназначен для быстрой авторизации в приложении"
            okText="Сохранить"
            cancelText="Отмена"
          />
        ) : (
          ""
        )}
      </div>
    );
  }

  componentDidMount() {
    if (this.inputRefs[0]) {
      this.inputRefs[0].focus();
    }

    this.getCodeInfo();

    // if (!localStorage.getItem('digitalkassir_idtn_cms_frm')) {
    //   setTimeout(() => this.props.navigate('/'), 0);
    // }
  }
}

export default withRouter(LoginCode);
